import { render } from "./info-form.vue?vue&type=template&id=45497468"
import script from "./info-form.vue?vue&type=script&lang=js"
export * from "./info-form.vue?vue&type=script&lang=js"

import "./info-form.vue?vue&type=style&index=0&id=45497468&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-form/info-form.vue'],['render',render],['__file',"info-form.vue"]])

export default __exports__